import './ProgressBadge.css';

interface ProgressBadgeProps {
  explored: number;
  total: number;
}

export function ProgressBadge({ explored, total }: ProgressBadgeProps) {
  const percentage = Math.round((explored / total) * 100);

  return (
    <div className="progress-badge">
      <div className="progress-badge__ring">
        <svg viewBox="0 0 36 36">
          <path
            className="progress-badge__bg"
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path
            className="progress-badge__fill"
            strokeDasharray={`${percentage}, 100`}
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
          />
        </svg>
        <span className="progress-badge__count">{explored}</span>
      </div>
      <div className="progress-badge__text">
        <span className="progress-badge__label">{explored}/{total} explored</span>
        {explored >= 3 && explored < total && (
          <span className="progress-badge__achievement">
            <i className="fas fa-star"></i> {explored} notations discovered
          </span>
        )}
        {explored === total && (
          <span className="progress-badge__achievement progress-badge__achievement--complete">
            <i className="fas fa-trophy"></i> Complete!
          </span>
        )}
      </div>
    </div>
  );
}
